/**
 * Portal sidebar entries — role predicates match the former PortalLayout gates.
 */
export interface PortalNavLink {
  label: string;
  path: string;
  /** Returns true when the current roles may see this link. */
  isVisible: (roles: readonly string[]) => boolean;
}

/** Top-level portal links previously shown in PortalLayout. */
export const PORTAL_NAV_LINKS: readonly PortalNavLink[] = [
  {
    label: 'Escalation Queue',
    path: '/escalation-queue',
    isVisible: (roles) => roles.includes('staff:rd') || roles.includes('staff:md'),
  },
];
